import { render, staticRenderFns } from "./newpage3.vue?vue&type=template&id=2f0bf00e&scoped=true&"
import script from "./newpage3.vue?vue&type=script&lang=js&"
export * from "./newpage3.vue?vue&type=script&lang=js&"
import style0 from "./newpage3.vue?vue&type=style&index=0&id=2f0bf00e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0bf00e",
  null
  
)

export default component.exports